<template>
    <section class="footer-con position-relative">
        <figure class="mb-0 footer-image">
            <img src="/src/assets/logos/enigma-fishing-logo-circle-white.png" alt="image" class="img-fluid">
        </figure>
        <div class="container position-relative">
            <div class="middle_portion">
                <div class="row">
                    <div class="col-xl-12 col-12 mx-auto">
                        <div class="row">
                            <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                                <div class="logo-content">
                                    <router-link to="/" class="footer-logo">
                                        <figure class="mb-0"><img
                                                src="/src/assets/logos/enigma-fishing-logo-words-white.png" alt="image">
                                        </figure>
                                    </router-link>
                                    <p class="text text-size-16 mb-0">{{ $t('footer.description') }}</p>
                                    <p class="text text-size-16 mb-0">
                                        <a href="https://www.instagram.com/enigma_fishing" target="_blank"
                                            class="text-decoration-none">
                                            <i class="fa-brands fa-instagram social-networks instagram-link mt-4"
                                                aria-hidden="true"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-4 col-6">
                                <div class="links">
                                    <h6 class="heading">{{ $t('footer.fishingTrips') }}</h6>
                                    <ul class="list-unstyled mb-0">
                                        <li>
                                            <router-link :to="{ name: localizedRouteName('LightTackle') }"
                                                class="text-decoration-none">
                                                {{ $t('navigation.lightTackle') }}
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link :to="{ name: localizedRouteName('BottomFishing') }"
                                                class="text-decoration-none">
                                                {{ $t('navigation.bottomFishing') }}
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link :to="{ name: localizedRouteName('AmberjackFishing') }"
                                                class="text-decoration-none">
                                                {{ $t('navigation.amberjackFishing') }}
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link :to="{ name: localizedRouteName('DentexFishing') }"
                                                class="text-decoration-none">
                                                {{ $t('navigation.dentexFishing') }}
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link :to="{ name: localizedRouteName('GiantBluefinTuna') }"
                                                class="text-decoration-none">
                                                {{ $t('navigation.giantBluefin') }}
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link :to="{ name: localizedRouteName('DeepSeaTrolling') }">
                                                {{ $t('navigation.deepSeaTrolling') }}
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-4 col-6">
                                <div class="links">
                                    <h6 class="heading">{{ $t('footer.privateBoat') }}</h6>
                                    <ul class="list-unstyled mb-0">
                                        <li>
                                            <router-link :to="{ name: localizedRouteName('PrivateBoat') }"
                                                class="text-decoration-none">
                                                {{ $t('navigation.paseoExpress') }}
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link :to="{ name: localizedRouteName('PrivateBoat') }"
                                                class="text-decoration-none">
                                                {{ $t('navigation.aventuraTapas') }}
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link :to="{ name: localizedRouteName('PrivateBoat') }"
                                                class="text-decoration-none">
                                                {{ $t('navigation.rutaCalasSecretas') }}
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-4 col-6">
                                <div class="contact">
                                    <h6 class="heading">{{ $t('footer.contactInfo') }}</h6>
                                    <ul class="list-unstyled mb-0">
                                        <li class="text">
                                            <i class="fa-solid fa-location-dot mr-2"></i>
                                            <a href="https://maps.app.goo.gl/zLVnb5EqHAM7y127A"> Passeig Marítim, 16.
                                                07400 Port d'Alcúdia, Illes Balears</a>
                                        </li>
                                        <li class="text">
                                            <i class="fa-solid fa-envelope mr-2"></i>
                                            <a
                                                href="mailto:info@fishing-charter-mallorca.com">info@fishing-charter-mallorca.com</a>
                                        </li>
                                        <li class="text">
                                            <i class="fa-solid fa-phone mr-2"></i>
                                            <a href="tel:+34667587512">+34 667 587 512</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="copyright">
            <p class="mb-0 text-size-14">{{ $t('footer.copyright', { year: new Date().getFullYear() }) }} · <a href="#"
                    @click.prevent="$klaro.show()">{{ $t('footer.manageCookies') }}</a></p>
        </div>
    </section>
</template>

<script>
import { useRouteLocalization } from '@/composables/useRouteLocalization'

export default {
    name: 'Footer',
    setup() {
        const { localizedRouteName } = useRouteLocalization()

        return {
            localizedRouteName
        }
    },
}
</script>

<style scoped>
/* Els estils es carregaran de manera global */
.footer-con .middle_portion .contact .text {
    color: #b2c9d8;
}

.footer-con a {
    color: #b2c9d8;
}

.instagram-link {
    font-size: 40px;
}
</style>